module.exports = "dist/images/components-image-shape-control-default.f59a6f2.png";